// Grindsted Vandværk - Strukturerede data og aktiver

export const CONTACT_INFO = {
  name: "Grindsted Vandværk",
  address: "Smedevej 4",
  zipCity: "9310 Vodskov",
  phone: "40 19 70 78",
  email: "grv@grindsted-vand.dk",
  openingHours: [
    { day: "Mandag", hours: "10.00 - 12.00" },
    { day: "Tirsdag", hours: "10.00 - 12.00" },
    { day: "Onsdag", hours: "10.00 - 12.00" },
    { day: "Torsdag", hours: "10.00 - 12.00" },
    { day: "Fredag", hours: "10.00 - 12.00" },
  ],
  phoneOffice: "61 28 65 29",
};

export const EMERGENCY_CONTACT = {
  company: "Holm El og VVS A/S",
  address: "Følfodvej 15, 9310 Vodskov",
  phone: "98 29 39 66",
  email: "michael@holmelvvs.dk",
};

export const ADMINISTRATION_CONTACT = {
  company: "Aspro",
  role: "Administration & Afregning",
  phone: "86 16 96 32",
  description: "Håndterer forbrugsafregning, flyttemeldinger og administrative spørgsmål.",
};

export const BOARD_MEMBERS = [
  {
    role: "Forretningsfører",
    name: "Ole Dahl",
    address: "Overblikket 2, 9000 Aalborg",
    phone: "61 28 65 29",
    email: "ole_dahl@stofanet.dk",
  },
  {
    role: "Formand",
    name: "Carsten Pedersen",
    address: "Smedevej 4, Grindsted, 9310 Vodskov",
    phone: "40 19 70 78",
    email: "formand@grindsted-vand.dk",
  },
  {
    role: "Næstformand",
    name: "Thomas Juul",
    address: "Uggerhalnevej 59, Grindsted, 9310 Vodskov",
    phone: "98 28 61 78",
    email: "juliusx@icloud.com",
  },
  {
    role: "Bestyrelsesmedlem",
    name: "Niels Jørgen Frederiksen",
    address: "Sølgårdsvej 13, 9381 Sulsted",
    phone: "24 63 31 95",
    email: "nielsfrederiksen@jubii.dk",
  },
  {
    role: "Bestyrelsesmedlem",
    name: "Hans-Erik Pedersen",
    address: "Tranevej 27, 9310 Vodskov",
    phone: "22 92 20 45",
    email: "tranehl@gmail.com",
  },
  {
    role: "Bestyrelsesmedlem",
    name: "Carsten Christensen",
    address: "Uggerhalnevej, Grindsted, 9310 Vodskov",
    phone: "",
    email: "carstenc79@gmail.com",
  },
];

export const DOCUMENTS = {
  takstblad: {
    title: "Takstblad 2026",
    description: "Priser for vandforbrug, faste afgifter og tilslutningsbidrag gældende for 2026.",
    url: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/71797ece-2d7d-4930-85a8-28fce40a7687.pdf",
  },
  regulativ: {
    title: "Regulativ",
    description: "Vandværkets gældende regulativ godkendt af Aalborg Kommune.",
    url: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/6489dd1f-01e9-498b-a5ed-e8f9ef3ca912.pdf",
  },
  vedtaegter: {
    title: "Vedtægter",
    description: "Vedtægter for det andelsselskab, som Grindsted Vandværk er organiseret som.",
    url: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/f01309a5-079a-4308-beb4-2d370b4df474.pdf",
  },
  annualReports: [
    {
      year: "2025",
      title: "Årsrapport 2025",
      url: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/9e2403db-5aa3-4c79-9e68-7064c97bee2b.pdf",
    },
    {
      year: "2024",
      title: "Årsrapport 2024",
      url: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/a96b7e09-7d5a-4d1f-95f1-047e4594d307.pdf",
    },
    {
      year: "2023",
      title: "Årsrapport 2023",
      url: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/780aa034-7654-47aa-a16e-adcbaea4280e.pdf",
    },
    {
      year: "2022",
      title: "Årsrapport 2022",
      url: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/c07dabb4-c3f2-43f1-bbb2-7c2349dac317.pdf",
    },
    {
      year: "2021",
      title: "Årsrapport 2021",
      url: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/004ec742-472e-42e6-8f08-24122cfb4d81.pdf",
    },
    {
      year: "2020",
      title: "Årsrapport 2020",
      url: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/201a1ad5-56c2-4258-ad18-9d6d9c6fbb60.pdf",
    },
  ],
  generalAssembly: {
    referat: {
      title: "Generalforsamling - 26. februar 2026",
      description: "Referat fra den seneste generalforsamling afholdt i februar 2026.",
      url: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/e8e9b439-0225-4c01-a89e-056c1ff46b2c.pdf",
    },
    beretning: {
      title: "Formandens Beretning 2026",
      description: "Formandens beretning om årets gang og værkets tilstand.",
      url: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/38811c2c-9259-4082-8139-95d1bf6cf11f.pdf",
    },
  },
};

export const WATER_ANALYSES = [
  {
    site: "Espelunden",
    description: "Vandprøver udtaget fra boringen eller afgang værk ved Espelunden.",
    pdfUrl: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/e20d4036-d0da-4c5a-b28f-0987c0a6f9d4.pdf",
    imageUrl: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/4ee21b7e-c9e3-4ff5-87a2-ea15d484e504.png",
    photoUrl: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/613d7e81-b306-44ff-a288-1a37bb98e76d.jpg",
  },
  {
    site: "Tranevej",
    description: "Vandprøver udtaget fra boringen eller afgang værk ved Tranevej.",
    pdfUrl: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/4aff62dc-007d-4739-86f7-ad5a74de3e7f.pdf",
    imageUrl: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/e117492f-8301-449a-85eb-08200ed13201.png",
    photoUrl: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/5ae44bee-2fa0-4c0a-8791-778adc19f902.jpg",
  },
];

export const IMAGES = {
  waterworksHero: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/0a0cb20a-436b-4e2d-a32a-547d1214cc77.jpg",
  waterworksSecondary: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/e61bf7bf-905f-45d9-84ec-4d67608ad62c.jpg",
  waterworksDetail: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/f845d549-6f18-4d5c-bca3-fd96ef449f16.jpg",
  supplyMap: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/d8eb5def-36ad-461c-b40c-197e68fcdca2.jpg",
  supplyMapAlt: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/40799b8b-c97b-4cab-be95-4b26e3d5e87e.jpg",
  movingHero: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/e8672f6c-b9c5-4777-bed7-12cb572ba8a4.jpg",
  gallery: [
    "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/e61bf7bf-905f-45d9-84ec-4d67608ad62c.jpg",
    "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/f845d549-6f18-4d5c-bca3-fd96ef449f16.jpg",
    "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/f39f0ac9-11b4-4d06-8b00-e79c6000ef15.jpg",
    "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/eee8abda-9e56-4a00-a5cd-87412283bff7.jpg",
    "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/c5c93e15-fb71-4e6d-931d-c43a1db1e176.jpg",
    "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/0e35501b-10b5-4c09-9998-cf146121fa6b.jpg",
    "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/3dbc7bd0-b1d3-41f8-8742-2a3efc37670d.jpg",
    "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/d4474467-dc60-43d1-80a5-92727c48394f.jpg",
  ],
  logos: {
    danskeVandvaerker: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/4c61d485-0c48-4b83-ad0a-672dba8b24da.png",
    geus: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/0ac7a5d3-3fda-4eeb-aa6f-dafb9d1de3d6.png",
    aalborgKommune: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/4ac7fc42-24d1-47db-90ce-c53b13bdf228.png",
    miljoestyrelsen: "https://assets.auxodev.dk/assets/74070791-98c6-4435-9dcf-71cab0b4761c/46f8f1e8-51f9-40c9-aa70-ec852e7419a5.png",
  }
};

export const USEFUL_LINKS = [
  {
    title: "Danske Vandværker",
    description: "Brancheforeningen for almene vandværker i Danmark.",
    url: "https://danskevv.dk",
    logo: IMAGES.logos.danskeVandvaerker,
  },
  {
    title: "GEUS",
    description: "De Nationale Geologiske Undersøgelser for Danmark og Grønland.",
    url: "https://www.geus.dk",
    logo: IMAGES.logos.geus,
  },
  {
    title: "Aalborg Kommune",
    description: "Tilsynsmyndighed og kommunal administration for Grindsted Vandværk.",
    url: "https://www.aalborg.dk",
    logo: IMAGES.logos.aalborgKommune,
  },
  {
    title: "Miljøstyrelsen",
    description: "Statens myndighed for miljøbeskyttelse og vandressourcer.",
    url: "https://mst.dk",
    logo: IMAGES.logos.miljoestyrelsen,
  },
];
